import { render } from "./WaPaymentHistory.vue?vue&type=template&id=a095362c&scoped=true"
import script from "./WaPaymentHistory.vue?vue&type=script&lang=js"
export * from "./WaPaymentHistory.vue?vue&type=script&lang=js"

import "./WaPaymentHistory.vue?vue&type=style&index=0&id=a095362c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a095362c"]])

export default __exports__